import { get, post } from "../utils/request";

/**
 * 获取新闻列表
 * @param {*} vm
 * @param {*} cb
 */
export const getNewsList = (vm, cb) => {
  let params = {
    pageNo: vm.current,
    pageSize: vm.display
  };
  vm.tipsData = [];
  vm.isloading = true;
  vm.nodata = false;
  post("/api/news/newsList", params)
    .then(res => {
      vm.isloading = false;
      if (res.code == 200) {
        vm.tipsData = res.data.list || [];
        vm.tipsData = vm.tipsData.map(item => {
          item.imgUrl = vm.comImgUrl + item.imgUrl;
          return item;
        });
        vm.news = vm.tipsData.map(item => {
          return item;
        });
        vm.total = res.data.total;
        vm.recData = res.data.top || {};
        if (JSON.stringify(vm.recData) != "{}") {
          vm.recData.imgUrl = vm.comImgUrl + vm.recData.imgUrl;
          vm.news.unshift(vm.recData);
        }
        vm.isShowRecommend = JSON.stringify(vm.recData) == "{}" ? false : true;
        if (vm.news.length > 4) {
          vm.news = vm.news.filter((item, index) => {
            return index < 4;
          });
        }
      }
      if (cb !== undefined) {
        cb();
      }
      vm.nodata = vm.tipsData.length == 0 ? true : false;
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.isloading = false;
      vm.nodata = vm.tipsData.length == 0 ? true : false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取新闻详情
 * @param {*} vm
 * @param {*} cb
 */
export const getNewsDetail = (vm, cb) => {
  let params = {
    id: vm.detailId
  };
  post("/api/news/newsById", params)
    .then(res => {
      //console.log(res);
      if (res.code === 200) {
        vm.detail = res.data || {};
        vm.detail.imgUrl = vm.comImgUrl + vm.detail.imgUrl;
      }
      if (cb !== undefined) {
        cb();
      }
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};
